import { useAppDispatch } from 'app/store/configureStore';
import { useCallback } from 'react';
import { InviteResponseType } from 'types/invite.types';
import { respondToInviteEffect } from 'app/store/Notifications/effects';
import { ApiErrorCodeMessages, ApiErrorCodeTypes } from 'types/enums';
import { removeInviteAction } from 'app/store/Notifications/slice';

interface UseRespondToInviteProps {
  setInvalidInviteMessage: (state: string) => void;
  setShowInactiveDialog: (state: boolean) => void;
  onResponded?: (response: InviteResponseType) => void;
}

export const useRespondToInvite = ({
  setInvalidInviteMessage,
  setShowInactiveDialog,
  onResponded,
}: UseRespondToInviteProps) => {
  const dispatch = useAppDispatch();
  const respondToInvite = useCallback(
    async (
      response: InviteResponseType,
      guid: string,
      inviterName: string,
      inviterGuid: string
    ) => {
      try {
        await dispatch(
          respondToInviteEffect({ response, guid, inviterGuid })
        ).unwrap();
      } catch (e: any) {
        if (
          e.response.data.error.errorCode ===
          ApiErrorCodeTypes.INVITE_IS_REVOKED
        ) {
          setInvalidInviteMessage(
            `${ApiErrorCodeMessages.INVITE_IS_REVOKED} ${
              inviterName ? `Please contact ${inviterName}.` : ''
            }`
          );
          setShowInactiveDialog(true);
          dispatch(removeInviteAction(guid));
        }
      } finally {
        if (onResponded) {
          onResponded(response);
        }
      }
    },
    [onResponded, dispatch, setInvalidInviteMessage, setShowInactiveDialog]
  );

  return { respondToInvite };
};
